/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'cloud-lock-outline': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M22 17c.5 0 1 .5 1 1v4c0 .5-.5 1-1 1h-5c-.5 0-1-.5-1-1v-4c0-.5.5-1 1-1v-1.5c0-1.4 1.1-2.5 2.5-2.5s2.5 1.1 2.5 2.5V17m-1 0v-1.5c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5V17h3m-3.5-6v-.5C17.5 7.46 15.04 5 12 5 9.5 5 7.37 6.69 6.71 9H6c-2.21 0-4 1.79-4 4s1.79 4 4 4h8.17a3 3 0 00-.17 1v1H6c-3.31 0-6-2.69-6-6 0-3.1 2.34-5.64 5.35-5.96A7.496 7.496 0 0112 3c3.64 0 6.67 2.6 7.36 6.04C21.95 9.22 24 11.36 24 14l-.06.77A4.497 4.497 0 0019.5 11h-2z"/>'
  }
})
